<template>
  <b-modal
    id="modal-payment"
    hide-header
    hide-footer
    ok-only
    ok-title="Accept"
    centered
    size="lg"
    title="Large Modal"
    class="custom__modal"
    @show="handleModalOpen"
  >
    <!-- Modal Header -->
    <ModalHeader
      :left-text="'Kembali'"
      :middle-text="'Pilih Metode Pembayaran'"
      :left-function="directPage"
      :is-rigt-column="true"
      :right-function="postPaymentOther"
      :right-text="'Simpan'"
    />
    
    <!-- Payment Methods -->
    <div class="form-payment mt-5 pt-5">
      <b-container>
        <b-row class="justify-content-center align-items-center">
          <b-col cols="8">
            <b-row class="mt-5 pt-5">
              <b-col
                v-for="(item, index) in payments"
                :key="index"
                cols="6"
              >
                <div 
                  class="payment-card-wrapper"
                  @click="selectPaymentMethod(item.value)"
                >
                  <b-card 
                    class="p-2 mb-2 payment-card" 
                    no-body 
                    :class="{ 'active': payment_method === item.value }"
                  >
                    <div class="d-flex align-items-center justify-content-between w-100">
                      <!-- Left Content -->
                      <div class="d-flex align-items-center flex-grow-1">
                        <div class="d-flex justify-content-center align-items-center rounded-circle image-box box-tempo">
                          <b-img
                            :src="require(`@/assets/images/icons/${item.image}.svg`)"
                            blank-color="#ccc"
                            width="18"
                            alt="placeholder"
                          />
                        </div>
                        <div class="ml-2">
                          <h6 class="text-dark fw-bold-800">
                            {{ item.name }} <span class="text-danger">*</span>
                          </h6>
                          <h6 class="text-dark text-darken-4 fw-bold-500 size12">
                            Pembayaran Langsung
                          </h6>
                        </div>
                      </div>
                      
                      <!-- Checkbox -->
                      <b-form-radio
                        :value="item.value"
                        v-model="payment_method"
                        :id="`payment-${index}`"
                        class="ml-2 custom-check-radio"
                      />
                    </div>
                  </b-card>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal, BRow, BCol, BContainer, BCard, BImg,BFormRadio
} from 'bootstrap-vue'
import { checkPermission, successNotification, errorNotification } from '@/auth/utils'
import ModalHeader from '@/components/ModalHeader.vue'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BContainer,
    BFormRadio,
    BCard,
    BImg,
    ModalHeader,
  },
  props: {
    postPaymentOther: {
      type: Function,
    },
  },
  setup() {
    return {
      checkPermission, successNotification, errorNotification,
    }
  },
  data() {
    return {
      payment_method: '',
      payment_date: '',
      payments: [
        //  cash,card,transfer,giro,wallet,piutang
        {
          name: 'Tunai',
          value: 'cash',
          image: 'tunai',
          class: 'image-box box-tempo',
        },
        {
          name: 'Transfer Bank',
          value: 'transfer',
          image: 'transfer',
          class: 'image-box box-transfer',
        },
        {
          name: 'Giro',
          value: 'giro',
          image: 'giro',
          class: 'image-box box-giro',
        },
      ],
    }
  },
  methods: {
    handleModalOpen() {
      this.payment_method = ''
    },
    directPage() {
      this.$bvModal.hide('modal-payment')
    },
    selectPaymentMethod(value) {
      this.payment_method = value
    },
  },
  watch: {
    payment_method(value) {
      this.$store.commit('payout/setPaymentMethod', value)
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/variables/_variables.scss';

.form-payment {
  .image-box {
    width: 46px;
    height: 46px;
  }

  .payment-card-wrapper {
    cursor: pointer;
    
    &:focus {
      outline: none;
    }
  }

  .payment-card {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
    border: 1px solid transparent;
    transition: all 0.2s ease;
    
    &:hover {
      background-color: rgba(0, 0, 0, 0.02);
    }
    
    &.active {
      border-color: $primary;
      background-color: rgba($primary, 0.05);
    }
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: $primary;
    border-color: $primary;
  }
}

/* Custom radio to look like checkbox with checkmark */
.custom-check-radio {
  .custom-control-label::before,
  .custom-control-label::after {
    border-radius: 4px; // make square instead of round
  }

  /* unchecked box style */
  .custom-control-label::before {
    width: 20px;
    height: 20px;
    border: 2px solid #ccc;
    background-color: #fff;
  }

  /* checked state with checkmark */
  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: $primary;
    border-color: $primary;
  }

  .custom-control-input:checked ~ .custom-control-label::after {
    content: "✔";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -55%);
    font-size: 14px;
    color: #fff;
  }
}

#modal-payment {
  .modal-body {
    background: #F6F7FA;
  }
}
</style>